/**
 * GA4 names its session cookie with the measurement ID suffix even though
 * Firebase requires the full `G-...` measurement ID in app configuration.
 */
export function getGoogleAnalyticsSessionCookieName(
  measurementId: string | null | undefined
): string | null {
  const measurementIdSuffix = measurementId?.trim().replace(/^G-/i, "");
  return measurementIdSuffix ? `_ga_${measurementIdSuffix}` : null;
}
